import { Controller } from "@hotwired/stimulus"
import { LogoHelper } from "~/helpers/logo_helper"

export default class extends Controller {
  static get targets() {
    return ["logo", "input", "clear"]
  }

  static get values() {
    return { name: String }
  }

  select(event) {
    this.logoTarget.src = LogoHelper.companyLogoUrl(event.detail.domain)
    this.logoTarget.classList.remove("d-none")
    this.clearTarget.classList.remove("d-none")
    this._dispatchFilterEvent()

    this.inputTarget.blur()
    $(this.inputTarget).autocomplete("hide")
  }

  clear() {
    this.logoTarget.classList.add("d-none")
    this.clearTarget.classList.add("d-none")
    this.logoTarget.src = ""
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this._dispatchFilterEvent()
  }

  submit(event) {
    const domainName = App.hostnameFromURL(event.target.value)

    if (App.isADomainName(domainName)) {
      let output = { detail: { domain: domainName } }
      this.inputTarget.value = domainName
      this.select(output)
    }
  }

  // Dispatch the filter event, this can be used with other elements to apply the filters.
  _dispatchFilterEvent() {
    this.dispatch("filters", {
      detail: {
        filters: [{ name: `${this.nameValue}`, values: this.inputTarget.value }],
      },
    })
  }
}
